import React from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function PageWrapper(ComposedComponent) {
    return function (props) {
        return <>
            <ComposedComponent {...props} />
            <ToastContainer />
        </>
    }
}

export default composedComponent => PageWrapper(composedComponent);